import React, { useEffect, useState } from 'react';
import { AutoComplete, Input } from 'antd';
import type { AutoCompleteProps } from 'antd';
import { Transput } from '../../Models/Platform/Transput';
import { use } from 'i18next';
import { useTranslation } from 'react-i18next';

const getRandomInt = (max: number, min = 0) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const searchResult = (query: string, transputs: Transput[]) => {
  return transputs
    .filter(
      (transput) =>
        transput.id.toLowerCase().includes(query.toLowerCase()) ||
        transput.name.toLowerCase().includes(query.toLowerCase()),
    )
    .map((transput, idx) => {
      const category = `${query}${idx}`;

      return {
        value: transput.sensorId,
        label: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              minWidth: '300px',
            }}
          >
            <span>
              {transput.name} in {transput.description}
              {/* <a
                href={`https://s.taobao.com/search?q=${query}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {category}
              </a> */}
            </span>
          </div>
        ),
      };
    });
};

const CustomSelecter = (props: {
  id?: string;
  transputs: Transput[];
  setTransputId: Function;
}) => {
  const { t, i18n } = useTranslation();

  const [options, setOptions] = useState<AutoCompleteProps['options']>([]);

  const handleSearch = (value: string) => {
    setOptions(searchResult(value, props.transputs));
  };

  const onSelect = (value: string) => {
    props.setTransputId(value);
  };

  return (
    <AutoComplete
      popupMatchSelectWidth={400}
      style={{ width: 400 }}
      options={options}
      onSelect={onSelect}
      onSearch={handleSearch}
      defaultValue={props.id == 'basic_sensorId'  ? '' : props.id}
    >
      <Input.Search
        defaultValue={props.id}
        size="middle"
        placeholder={t('search')}
        enterButton
      />
    </AutoComplete>
  );
};

export default CustomSelecter;
//
